import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PrimaryButton from '../../../../ui/PrimaryButton';
import IfmsModal from '../../../../ui/IfmsModal';
import useTableNavigation from '../../../../ui/tables/useTableNavigation';
import ApplicationContext from '../../../../ApplicationContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';

import { ApplicableTableSettings, buyingRateList } from '../../../../tableSettings';

import {
  DateRenderer,
  FloatRenderer,
  TextAlignLeftRenderer,
  TextRenderer,
} from '../../../../uiControls/SmartTableRenderers';

import SmartTable from '../../../../uiControls/SmartTable';
import SecondaryButton from '../../../../ui/SecondaryButton';
import useFunction from '../../../../hooks/useFunction';
import { Search, initialSearch } from '../../../../filtering';
import InputControlRow from '../../../../ui/layout/InputControlRow';
import TextBox from '../../../../ui/TextBox';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import CloseButton from '../../../../ui/CloseButton';
import { JobNames } from '../../../../framework.core/JobNames';
import useDirtyCheck from '../../../../hooks/useDirtyCheck2';
import { ApiResult, InsertResultsWithData } from '../../../../framework.core/data/ApiResult';
import { TrackableEntity } from '../../../../fms.core/data/ChangeTrackable';
import { getSQLInfoList } from '../../../../fms.core/data/TrackingModule';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { CarrierInfo, sortingListData } from '../../ReferenceFiles';
import _ from 'lodash';
import { RateTableListItem } from '../../../../fms.data/models/RateTableListItem';
import { RateTable } from '../../../../fms.core/RateTable';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import Select from '../../../../ui/Select';
import Date from '../../../../ui/Date';
import Float from '../../../../ui/Float';
import MultilineTextBox from '../../../../ui/MultilineTextBox';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";
import postal from 'postal';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import { Portal } from 'react-portal';
import GreenButton from '../../../../ui/GreenButton';

function RowSpacer() {
  return (
    <div style={{height: '10px'}}>&nbsp;</div>
  );
}

export function BuyingRateDetail({
  readonly,
  buyingRate,
  onChange
}: {
  readonly: boolean,
  buyingRate: RateTable,
  onChange: (change: Partial<RateTable>) => void,
}) {
  return (
    <div>
      <div style={{float: 'left', marginRight: '10px', width: 'calc(50% - 10px)'}}>
        <RowSpacer />

        <InlineInputControlRow label="Carrier" mode = 'xsmall' smallMargin>
          <TextBox name='buyingrate-carrier' disabled maxLength={50} value={buyingRate?.carrier || ''} onChange={e => onChange({ carrier: e.target.value })} />
        </InlineInputControlRow>
        <InlineInputControlRow smallMargin mode="xsmall" label="Mode">
            <div style={{width: 80}}>
                      <Select
                        maxLength={3}
                        name='buyingrate-mode'
                        selectId='carrier-mode'
                        value={buyingRate.mode}
                        disabled={readonly}
                        onChange={e => onChange({ mode: e.target.value})}
                        items={[
                          { label: 'FCL', value: 'FCL'},
                          { label: 'LCL', value: 'LCL'},
                        ]}
                      />
            </div>          
          </InlineInputControlRow>

          <InlineInputControlRow mode="xsmall" smallMargin label="Valid From">
                        <LeftRightSplit
                          leftSize="80px"
                          rightSize="calc(100% - 80px)"
                          left={
                            <Date
                              name='buyingrate-validFrom'
                              disabled={readonly}
                              value={buyingRate.effectETD}
                              onChange={(effectETD => onChange({effectETD}))}
                            />
                          }
                          right={
                            <div style={{paddingLeft: '10px'}}>
                              <LeftRightSplit
                                leftSize="calc(100% - 80px)"
                                rightSize="80px"
                                left={<div style={{textAlign: 'center'}}>Valid By</div>}
                                right={
                                    <Date
                                      name='buyingrate-validBy'
                                      disabled={readonly}
                                      value={buyingRate.expireETD}
                                      onChange={(expireETD => onChange({expireETD}))}
                                    />
                                }/>
                            </div>
                          }
                        />
          </InlineInputControlRow>
          <InlineInputControlRow label="Origin" mode = 'xsmall' smallMargin>
          <TextBox name='buyingrate-origin' disabled={readonly} maxLength={25} value={buyingRate?.origin || ''} onChange={e => onChange({ origin: e.target.value })} />
          </InlineInputControlRow>                
          <InlineInputControlRow label="Destination" mode = 'xsmall' smallMargin>
          <TextBox name='buyingrate-destination' disabled={readonly} maxLength={25} value={buyingRate?.destination || ''} onChange={e => onChange({ destination: e.target.value })} />
          </InlineInputControlRow>  
          <RowSpacer />
          <InputControlRow label="Remark">
          <div style={{width: '600px'}} >
            <MultilineTextBox name='buyingrate-remark'  disabled={readonly} maxLength={3500} style={{height: 138}} value={buyingRate.remark} onChange={e => onChange({remark: e.target.value})}
                            />
          </div>
        </InputControlRow>
      </div>
      <div style={{float: 'left', paddingLeft: '25px', marginRight: '10px', width: 'calc(50% - 10px)'}}>
        <RowSpacer />

        <InlineInputControlRow label="CNTR Type" mode = 'xsmall' smallMargin>
          <div style={{width:'80px'}}>
            <TextBox name='buyingrate-size' disabled={readonly} maxLength={6} value={buyingRate?.size || ''} onChange={e => onChange({ size: e.target.value })} />
          </div>
        </InlineInputControlRow>
        <InlineInputControlRow label="Rate" mode = 'xsmall' smallMargin>
          <div style={{width:'80px'}}>
           <Float name='buyingrate-rate' disabled={readonly} decimals={2} max={9999999.99} min={0} value={buyingRate.rate1} onChange={rate1 => onChange({rate1: rate1??0})} />
          </div>
        </InlineInputControlRow>
        <InlineInputControlRow label="Commodity" mode = 'xsmall' smallMargin>
          <TextBox name='buyingrate-commodity' disabled={readonly} maxLength = {30} value={buyingRate?.commodity || ''} onChange={e => onChange({commodity: e.target.value})} />
        </InlineInputControlRow>
        
        <InlineInputControlRow label="Transit" mode = 'xsmall' smallMargin>
           <LeftRightSplit
                          leftSize="80px"
                          rightSize="calc(100% - 80px)"
                          left={
                            <Float name='buyingrate-transit' disabled={readonly} max={99999} min={0} decimals={0} value={buyingRate?.transit} onChange={transit => onChange({transit: transit??0})}
                                onTabNext={() => {
                                  document.getElementById('carrier-mode')?.focus();
                                  return true;
                                }} />

                          }
                          right={
                            <div style={{paddingLeft: '5px'}}>
                             days
                            </div>
                          }
                        />
        </InlineInputControlRow>
      </div>
                    
    </div>  
  );
}

function formatElement(data:any, index:number) {
  return {
    ...data,
    companyName: data.company?.shortName ?? '',
    indicator: index + 1
  };
}

function formatData(data: Array<RateTable>) {
  return data.map((d, i) => formatElement(d, i));
}

function BuyingRate({
  componentIndex,
  carrierBuyRate
}: {
  componentIndex: number,
  carrierBuyRate: CarrierInfo
}) {
  useFunction({
    invokers: {
      ifmsReferenceFilesSave: save,
      ifmsReferenceFilesCancel: cancelOperation,
    }
  });
  useFunctionKeys({ onEsc: cancelOperation});
  
  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const {selectTableRow, tableNavigationCleanup } = useTableNavigation('codes-buyingRate-list', onRowSelect, onRowDoubleSelect, ['carrier'], false, false, false);

  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-buyingRate-list`, []);
  //const [viewId, setViewId] = useTypedFastStorage<number>(`ifms-referenceFiles-buyingRate-view-id`, -1);
  const [buyingRate, _setBuyingRate, removeBuyingRateFromStorage] = useTypedFastStorage<RateTable>(`ifms-referenceFiles-buyingRate-editable`, null);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-buyingRate-orderby`, {
    orderBy: 'carrier',
    orderByAscending: true,
    // general1: 'Carrier',
    // pageSize: systemSettings.defaultPageSize,
    // tbId:carrierBuyRate.tbId,
  });
  //<pt220818: portal>
  const {setCleanState, dirtyCleanup} = useDirtyCheck(`ifms-referenceFiles-buyingRate-editable`, ['edit', 'view']);
  const [selectedRow, setSelectedRow] = useState(-1);
  const { FilterButton, search } = useFilterBar(
    buyingRateList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex)
  );

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'carrier',
      orderByAscending: true,
    };
  }

  function setBuyingRate(c:Partial<RateTable>, skipDirty:boolean = false) {
    if (!skipDirty) {
      setHasChanges(true);
    }
    _setBuyingRate(c);
  }

  const tableHeight = 520;

  function setData(d:Array<RateTable>) {
    removeData();
    _setData(d);
  }

  async function fetchData(api:any, search:Search) {
    const searchTemp = {...search, tbid: carrierBuyRate.tbId};

    setLoading(true);
    const apiResult = await api.getListItems(JobNames.SellingRate,
      'RateTableListItem',
      RateTableListItem.calculateSearchParameters(searchTemp, RateTableListItem.MapSearchFields),
      1,
      searchTemp.pageSize);

    const fetchedTableData  = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    sortingListData(RateTableListItem, fetchedTableData , setData, orderBy);
    setHasChanges(false);
    setLoading(false);
  }
/*
  function checkViewIdOnInitialLoad() {
    if (!viewId || viewId <= 0) {
      return;
    }

    setViewId(-1);
  }
*/
  useEffect(() => {
    // async function executeAsyncFunc() {
    //     await reload();
    // }
    // executeAsyncFunc();
    return () => {
      removeData();
      tableNavigationCleanup();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );
  
  useEffect(() => {
    if (dataRef.current?.length > 0 && loading === false) {
      selectTableRow(0);
      onRowSelect(0);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function onRowSelect(rowIndex: number){
    setSelectedRow(!isNaN(rowIndex) ? rowIndex: -1);
  }

  async function onRowDoubleSelect(rowIndex:number) {
    if (!dataRef || !dataRef.current) {
      return;
    }

    const apiResult:ApiResult<RateTable> = await appContext.api.getJobDetail(JobNames.SellingRate,
      {id: dataRef.current[rowIndex].id });
    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return;
    }

    const objScac = {...apiResult.result, edit: true, view: true, editIndex: rowIndex};
    setCleanState(objScac);
    const tEntity = new RateTable(objScac);
    tEntity.trackable = true;
    setBuyingRate(tEntity, true);
    //pt220818>
  }

  async function setBuyingRateDetail(isView: boolean){
    const apiResult:ApiResult<RateTable> = await appContext.api.getJobDetail(JobNames.SellingRate,
      {jobId: dataRef.current[selectedRow].id });
    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return;
    }

    const objScac = {...apiResult.result, edit: true, view: isView, editIndex: selectedRow};
    setCleanState(objScac);
    const tEntity = new RateTable(objScac);
    tEntity.trackable = true;
    setBuyingRate(tEntity, true);
  }

  // async function reload(generalText:string = '') {
  //   setOrderBy({
  //     orderBy: 'carrier',
  //     orderByAscending: true,
  //     pageSize: systemSettings.defaultPageSize,
  //     generalText1: generalText,
  //     tbId:carrierBuyRate.tbId,
  //   })
    
  //   await fetchData(appContext.api, orderBy);
  //   checkViewIdOnInitialLoad();
  // }

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
    //checkViewIdOnInitialLoad();
  }

  function onHeaderClick(header:any) {
    if (buyingRate !== null) {
      return;
    }

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({orderByAscending: !orderBy.orderByAscending});
      } else {
        setOrderBy({orderBy: header.id, orderByAscending: true});
      }
    }
    sortingListData(RateTableListItem, data, setData, orderBy);
  }

  function selectUserForNew() {

    const newCodeModel = new RateTable();   
    setBuyingRate(newCodeModel, false);
    newCodeModel.carrier = carrierBuyRate.code;
    newCodeModel.tbName = 'T_CODESCAC';
    newCodeModel.tbType = 88;
    newCodeModel.tbId = carrierBuyRate.tbId;
    setCleanState(newCodeModel);
    
    setBuyingRate({
      edit : false,
      view: false});
  }

  async function selectUserForEdit(){
    //clearTableSelection();
    await setBuyingRateDetail(false);
  }

  async function selectUserForView(){
    //clearTableSelection();
    await setBuyingRateDetail(true);
  }
  
  async function selectUserForDelete(){
    const doConfirm = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');
    if(doConfirm){
      const apiResult = await appContext.api.deleteJobDetail(JobNames.SellingRate, { id:dataRef.current[selectedRow].id });
      if (apiResult && apiResult.success) {
        await reload(false);
      }else
      showGlobalOkDialog(<p>{"Cannot delete"}</p>);
    }else
    return;
  }

  function cancelOperation() {
    const filterNode = document.getElementById('ifms-list-screen-filter');
    const channel = postal.channel('ifms-filter');

    if (!filterNode) {
      setHasChanges(false);
      removeBuyingRateFromStorage();
    } else {
      channel.publish('ifms-filter.dismiss');
    }
    return true;
  }

  async function save() {
    if (!buyingRate) {
      return;
    }

    const mainChange: Partial<RateTable>= {};
    const userID = appContext.user ? appContext.user.id ?? '' : '';
    if(buyingRate.edit === false && buyingRate.view === false){
      mainChange.u1Id = userID;
    }
    mainChange.u2Id = userID;
    if(!_.isEmpty(mainChange)){
      setBuyingRate(mainChange);
    }

    const sqlInfoList = getSQLInfoList(buyingRate as TrackableEntity);
    const apiResult:ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(
      JobNames.SellingRate,
      sqlInfoList
    );

    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return;
    }
 
    await showGlobalOkDialog(<p>The data has been saved</p>);
    
    cancelOperation();
    dirtyCleanup();
    await reload(false);

    //pt220818>
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-buyingRate-list',
    ref: tableRef,
    selectable: true,
    tableName: 'codesbuyingRateList',
    ...buyingRateList,
    height: `${tableHeight}px`,
    data: (data ?? []).map((x: any, i:number) => ({ ...x, indicator: (i + 1).toString(), })),
    rowRenderers: [
      { accessor: 'indicator', Cell: TextRenderer },
      { accessor: 'carrier', Cell: TextAlignLeftRenderer },
      { accessor: 'mode', Cell: TextRenderer },
      { accessor: 'origin', Cell: TextAlignLeftRenderer },
      { accessor: 'destination', Cell: TextAlignLeftRenderer },
      { accessor: 'commodity', Cell: TextAlignLeftRenderer },
      { accessor: 'size', Cell: TextAlignLeftRenderer },
      { accessor: 'transit', Cell: (props:any) => <FloatRenderer {...props} decimals={0} /> },
      { accessor: 'rate1', Cell: FloatRenderer },
      { accessor: 'effectETD', Cell: DateRenderer },
      { accessor: 'expireETD', Cell: DateRenderer },
      { accessor:'remark',  Cell: TextAlignLeftRenderer },
    ],
    orderBy: [orderBy],
    onHeaderClick,
  };

  const canBeAdd = buyingRate === null ;
  const canBeEdit = !isNaN(selectedRow) && !(selectedRow < 0);

  return (
    <div style={{ marginTop: '40px' }}>

      {/* <div style={{ width: '320px', fontWeight: 'bold' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      <div style={{ display: 'flex', width: '940px' }}>
      <div style={{marginLeft: 'auto'}}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          <SecondaryButton name='codes-buyingrate-add-button' size="regular" disabled={!canBeAdd} onClick={selectUserForNew}>New</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-buyingrate-view-button' size="regular" disabled={isNaN(selectedRow) || selectedRow < 0} onClick={selectUserForView}>View</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-buyingrate-edit-button' size="regular" disabled={!(canBeEdit && !isNaN(selectedRow) && !(selectedRow < 0))} onClick={selectUserForEdit}>Edit</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-buyingrate-delete-button' size="regular" disabled={isNaN(selectedRow) || selectedRow < 0} onClick={selectUserForDelete}>Delete</SecondaryButton>&nbsp;
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(false) }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      <div style={{ width: '940px' }}>
        <SmartTable {...tableOptions} />
      </div>
      <RowSpacer />

      <IfmsModal width="800px" height="450px" isOpen={!!buyingRate} title={buyingRate && buyingRate.edit ? (buyingRate.view ? 'Buying Rate View' : 'Buying Rate Edit') : 'Buying Rate New'} onCancel={cancelOperation}>
        {!!buyingRate &&
          <div>
            <div style={{display: 'flex'}}>
              <div style={{marginLeft: 'auto'}}></div>
              <div className="ifms-common-bar-element ifms-right-separator-light-gray">
                &nbsp;
                {buyingRate.view &&
                  <PrimaryButton name='buyingrate-detail-edit-button' size="regular" onClick={() => setBuyingRate({view: false}, true)}>Edit</PrimaryButton>
                }
                {!buyingRate.view &&
                  <GreenButton name='buyingrate-detail-save-button' size="regular" onClick={save}>Save</GreenButton>
                }
                &nbsp;
              </div>
              <div className="ifms-common-bar-element">
                <CloseButton name='buyingrate-detail-close-button' onClick={cancelOperation} />
              </div>&nbsp;&nbsp;
            </div>
            <BuyingRateDetail readonly={buyingRate.view} buyingRate={buyingRate} onChange={setBuyingRate} />
            <div style={{clear: 'both'}}></div>
          </div>
        }
      </IfmsModal>
    </div>
  );
}

export default BuyingRate;
